import { useQuery } from 'urql';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';
import { getSlugFromPathname } from '../../helpers/getSlugFromPathname';
import { usePropertyId } from '../../contexts/PropertyIdContext/PropertyIdContext';
import { headerCtasBySlugQuery } from '../graphql/headerCtasBySlugQuery';
import { useFeatureRollout } from '@rea-argonaut/experiment';

export const useHeaderCtasBySlugQuery = () => {
  const id = usePropertyId();
  const pathname = useUrlContext().pathname;
  const slug = getSlugFromPathname(pathname);
  const isPropertyReportEnabled = useFeatureRollout('property_report').isEnabled();

  return useQuery({
    query: headerCtasBySlugQuery,
    variables: {
      id,
      slug,
      isPropertyReportEnabled,
    },
  });
};

export const useHeaderCtasBySlugQueryContent = () => {
  const [result] = useHeaderCtasBySlugQuery();

  const propertyPageContent = result.data?.propertyPageBySlugV3;

  if (propertyPageContent?.__typename !== 'PropertyPage_Page') return null;

  return {
    ctas: propertyPageContent.header?.ctas,
    ctasV2: propertyPageContent.header?.ctasV2,
  };
};
